import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerFooter,
  Divider,
  Text,
  Flex
} from '@chakra-ui/react';
import { Profile } from './Profile';
import { SideBarButton } from './SideBarButton';
import { PersonAdd, Contacts } from '@material-ui/icons';
import { GoogleLogout } from 'react-google-login';

export const SideBar = ({ isOpen, onClose }) => {
  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };
  return (
    <>
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Navigation</DrawerHeader>
          <Divider orientation="horizontal" />

          <DrawerBody p="0">
            <Profile />

            <SideBarButton title="Your Contacts" icon={<Contacts />} link="/contacts" />
            <SideBarButton title="Save Contacts" icon={<PersonAdd />} link="/save-contacts" />
            <Flex mt={5} justifyContent={'center'} alignItems={'center'}>
              <GoogleLogout
                theme="dark"
                buttonText="Logout"
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                onLogoutSuccess={logout}
              />
            </Flex>
          </DrawerBody>
          <DrawerFooter>
            <Text>v1.0.0</Text>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
